import React from 'react';
import { TextField, Autocomplete } from '@mui/material';

const inputStyles = {
  '& .MuiInput-input': {
    fontSize: '0.875rem',
    padding: '2px 0',
  },
};

export function EditableTextField({ value, onChange, autoFocus }) {
  return (
    <TextField
      size="small"
      variant="standard"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      fullWidth
      autoFocus={autoFocus}
      sx={inputStyles}
    />
  );
}

export function EditableAutocomplete({ value, options, onChange }) {
  return (
    <Autocomplete
      size="small"
      options={options}
      value={value}
      onChange={(e, newValue) => onChange(newValue || '')}
      renderInput={(params) => (
        <TextField {...params} variant="standard" sx={inputStyles} />
      )}
      disableClearable
      sx={{ minWidth: 150 }}
    />
  );
}

